<template>
    <div class="d-footer">
        <div v-if="skew" class="skew-footer-top"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <router-link :to="{name: 'Index'}">
                        <img src="/static/images/logo/white_right.svg" style="height:50px;" alt="Deveo logo"/>
                    </router-link>
                    <p>
                        {{ $t('layout.footerAbout') }}
                    </p>
                    <div class="locale-wrapper">
                        <div class="locale"
                             v-for="(locale, index) in locales"
                             :key="index"
                             @click="$i18n.locale = index"
                             :class="{'active': $i18n.locale === index}"
                        >
                            <img v-if="index === 'da'" src="/static/images/flags/dk.png" alt="Danish"/>
                            <img v-if="index === 'en'" src="/static/images/flags/gb.png" alt="English" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-3">
                    <b>{{ $t('layout.footerMenuHeader') }}</b>
                    <a v-for="social in sortedSocials" :key="social.name" :href="social.link">
                        {{ social.name }}
                    </a>
                </div>
                <div class="col-lg-3 contact">
                    <b>{{ $t('layout.footerContactHeader') }}</b>
                    <a v-for="contact in contacts" :key="contact.icon" :href="contact.link">
                        <i v-if="contact.icon" :class="'fa fa-fw fa-' + contact.icon"></i>
                        <span v-html="contact.title"></span>
                    </a>
                </div>
                <div class="col-lg-12 copyright">
                    2014 - {{ currentYear }} &copy; Deveo ApS &nbsp;&nbsp; | &nbsp;&nbsp; CVR: 38994778
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'MainFooter',
        props: {
            skew: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data () {
            return {
                locales: this.$i18n.messages,
                socials: [
                    {
                        name: 'LinkedIn',
                        link: 'https://www.linkedin.com/company/17890131/'
                    },
                    {
                        name: 'Facebook',
                        link: 'https://www.facebook.com/deveodk/'
                    },
                    {
                        name: 'GitHub',
                        link: 'https://github.com/deveodk'
                    },
                    {
                        name: 'npmjs',
                        link: 'https://www.npmjs.com/~deveodk'
                    },
                    {
                        name: 'Open-source',
                        link: 'https://packages.deveo.io'
                    }
                ],
                contacts: [
                    {
                        title: '+45 71 99 28 95',
                        link: 'tel:+4571992895'
                    },
                    {
                        title: 'kontakt@deveo.dk',
                        link: 'mailto:kontakt@deveo.dk'
                    },
                    {
                        title: 'Nordborggade 8, st <br> 2100 København Ø',
                        link: 'https://www.google.dk/maps/place/Nordborggade+8,+2100+K%C3%B8benhavn+%C3%98/@55.6971168,12.5845689,17z/data=!4m13!1m7!3m6!1s0x465252e3f900106d:0x6181940053502815!2sNordborggade+8,+2100+K%C3%B8benhavn+%C3%98!3b1!8m2!3d55.6971168!4d12.5867576!3m4!1s0x465252e3f900106d:0x6181940053502815!8m2!3d55.6971168!4d12.5867576?hl=en'
                    }
                ]
            }
        },
        computed: {
            currentYear () {
                return new Date().getFullYear()
            },
            sortedSocials: function () {
                function compare (a, b) {
                    if (a.name < b.name) {
                        return -1
                    }
                    if (a.name > b.name) {
                        return 1
                    }
                    return 0
                }

                return this.socials.sort(compare)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .locale{
        display: inline-block;
        transition: 0.3s ease all;
        img{
            width: 30px;
        }
    }
    .locale.active{
        display: none;
    }
    .locale:hover{
        cursor: pointer;
        transform: scale(1.05);
    }
    .row div:first-of-type p{
        font-weight: 200;
        font-size: 14px;
        margin: 30px 0;
    }
    .col-lg-3{
        padding-top: 30px;
        font-weight: 300;
        font-size: 14px;
        b{
            display: block;
            margin-bottom: 15px;
        }
        a{
            opacity: 0.75;
            display: block;
            transition: 0.3s ease all;
        }
        a:not(:last-of-type){
            margin-bottom: 5px;
        }
        a:hover{
            text-decoration: none;
            color: #fff;
            opacity: 1;
        }
    }
    .col-lg-3.contact a:nth-of-type(1),
    .col-lg-3.contact a:nth-of-type(2){
        margin-bottom: 20px;
    }
    select{
        color: #000 !important;
    }
</style>



// WEBPACK FOOTER //
// footer.vue?5b2d559e